var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayYellowStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2147 0.878115C12.3045 0.601722 12.6955 0.601722 12.7853 0.878115L15.1268 8.0845C15.167 8.20811 15.2822 8.2918 15.4121 8.2918H22.9894C23.28 8.2918 23.4008 8.66368 23.1657 8.8345L17.0356 13.2883C16.9304 13.3647 16.8864 13.5001 16.9266 13.6237L19.2681 20.8301C19.3579 21.1065 19.0416 21.3363 18.8065 21.1655L12.6763 16.7117C12.5712 16.6353 12.4288 16.6353 12.3237 16.7117L6.19355 21.1655C5.95843 21.3363 5.64209 21.1065 5.73189 20.8301L8.07339 13.6237C8.11355 13.5001 8.06956 13.3647 7.96441 13.2883L1.83429 8.8345C1.59918 8.66368 1.72001 8.2918 2.01063 8.2918H9.58787C9.71784 8.2918 9.83302 8.20811 9.87319 8.0845L12.2147 0.878115Z",
    fill: "#CBCCCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_46982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2147 0.878115C12.3045 0.601722 12.6955 0.601722 12.7853 0.878115L15.1268 8.0845C15.167 8.20811 15.2822 8.2918 15.4121 8.2918H22.9894C23.28 8.2918 23.4008 8.66368 23.1657 8.8345L17.0356 13.2883C16.9304 13.3647 16.8864 13.5001 16.9266 13.6237L19.2681 20.8301C19.3579 21.1065 19.0416 21.3363 18.8065 21.1655L12.6763 16.7117C12.5712 16.6353 12.4288 16.6353 12.3237 16.7117L6.19355 21.1655C5.95843 21.3363 5.64209 21.1065 5.73189 20.8301L8.07339 13.6237C8.11355 13.5001 8.06956 13.3647 7.96441 13.2883L1.83429 8.8345C1.59918 8.66368 1.72001 8.2918 2.01063 8.2918H9.58787C9.71784 8.2918 9.83302 8.20811 9.87319 8.0845L12.2147 0.878115Z",
    fill: "#F8B805"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_46982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    width: 18,
    height: 24,
    fill: "#F8B805"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayYellowStar);
export default __webpack_public_path__ + "static/media/GrayYellowStar.d1c0c658bd6c1e9c5c4f340f6519f859.svg";
export { ForwardRef as ReactComponent };